import {ReelsModule} from '@gongxigames/framework/slot/modules/reels/ReelsModule';
import {ReelsQuickStopState} from '@gongxigames/framework/slot/modules/reels/states/ReelsQuickStopState';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class FirecatcherReelsQuickStopState extends ReelsQuickStopState {
    protected onSpinEnded(): void {
        if (this.module.logic.nextAction === Action.RESPIN) {
            this.module.gotoState(ReelsModule.RESPIN_BASIC_STATE);
        } else {
            this.module.gotoState(ReelsModule.BASIC_STATE);
        }

        this.module.eventManager.emit(ReelsEvents.SPIN_ENDED);
    }
}
